import {PageIntro, Loading} from '../components/Common';
import {PublicDataError} from '../components/PublicDataState';
import {usePublicCollection} from '../hooks/usePublicCollection';
import {date} from '../lib/api';
import {Conversation} from './Home';

export default function Progress() {
  const {data: items, loading, error, reload} = usePublicCollection('/content');
  return <>
    <PageIntro id="progress" eyebrow="PROGRESS / FROM CONVICTION TO EXECUTION"
      title={<>The work behind<br/><em>the long-term vision.</em></>}
      description="Company perspectives, operating priorities and the evidence gates that matter."/>
    <section className="wrap updates-section" aria-busy={loading}>
      <div className="notice" data-testid="progress-disclosure">Source-based strategy updates. Verified commercial metrics will be published when approved evidence is available.</div>
      {loading ? <Loading/> : error ?
        <PublicDataError id="progress" label="Company updates" error={error} onRetry={reload}/> : <>
          {items.map((item, index) => <article className="update-row" key={item.id} data-testid={`update-${item.id}`}>
            <div><span className="eyebrow">{item.kind.toUpperCase()}</span><span className="caption">{date(item.updated_at)}</span></div>
            <div><h2 className="editorial-heading" data-testid={`update-title-${item.id}`}>{item.title}</h2>
              <p data-testid={`update-body-${item.id}`}>{item.body}</p>
              <span className="source-note">{item.source} · {item.verification}</span>
            </div><span className="update-number">{String(index + 1).padStart(2, '0')}</span>
          </article>)}
          {!items.length && <p className="empty" data-testid="progress-empty">No company updates have been published yet.</p>}
        </>}
    </section><Conversation/>
  </>;
}